var _circle, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(1 0 0 -1 12 14)",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.35,
    y: 8.6921,
    width: 15.3,
    height: 10.9579,
    rx: 0.702631,
    stroke: "#00212E",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49229 10.2632C7.49229 10.5945 7.76091 10.8632 8.09229 10.8632C8.42366 10.8632 8.69229 10.5945 8.69229 10.2632H7.49229ZM15.3081 10.2632C15.3081 10.5945 15.5767 10.8632 15.9081 10.8632C16.2394 10.8632 16.5081 10.5945 16.5081 10.2632H15.3081ZM8.69229 10.2632C8.69229 8.81951 8.9718 7.2912 9.55043 6.14751C10.1259 5.01005 10.9354 4.35 12.0002 4.35V3.15C10.3152 3.15 9.17069 4.23995 8.47967 5.60578C7.7918 6.96538 7.49229 8.69365 7.49229 10.2632H8.69229ZM12.0002 4.35C13.0776 4.35 13.8832 4.98298 14.4518 6.08785C15.0273 7.20614 15.3081 8.73126 15.3081 10.2632H16.5081C16.5081 8.61299 16.2098 6.88153 15.5188 5.53876C14.8209 4.18257 13.6726 3.15 12.0002 3.15V4.35Z",
    fill: "#00212E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.bc1514563a8e27197fce12cd293a96ea.svg";
export { ForwardRef as ReactComponent };